import { find } from "lodash";

export default ({ allocationProjects }) =>
  find(allocationProjects, (allocationProject) => allocationProject.isActive);
